declare namespace $ {

	type $shm_hitalama_hovered__hovered_shm_hitalama_taskmanager_card_1 = $mol_type_enforce<
		ReturnType< $shm_hitalama_taskmanager_card['hovered'] >
		,
		ReturnType< $shm_hitalama_hovered['hovered'] >
	>
	type $mol_view__sub_shm_hitalama_taskmanager_card_2 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_taskmanager_card_3 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_hitalama_taskmanager_priority__hint_shm_hitalama_taskmanager_card_4 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_taskmanager_priority['hint'] >
	>
	type $shm_hitalama_taskmanager_priority__value_shm_hitalama_taskmanager_card_5 = $mol_type_enforce<
		ReturnType< $shm_hitalama_taskmanager_card['priority'] >
		,
		ReturnType< $shm_hitalama_taskmanager_priority['value'] >
	>
	type $mol_button_minor__hint_shm_hitalama_taskmanager_card_6 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__enabled_shm_hitalama_taskmanager_card_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_taskmanager_card['previous_enabled'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_shm_hitalama_taskmanager_card_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_taskmanager_card['move_left'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_taskmanager_card_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_shm_hitalama_taskmanager_card_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_hitalama_textarea__value_shm_hitalama_taskmanager_card_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_taskmanager_card['title'] >
		,
		ReturnType< $shm_hitalama_textarea['value'] >
	>
	type $shm_hitalama_textarea__hint_shm_hitalama_taskmanager_card_12 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_hitalama_textarea['hint'] >
	>
	type $mol_button_major__title_shm_hitalama_taskmanager_card_13 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_major['title'] >
	>
	type $mol_button_major__click_shm_hitalama_taskmanager_card_14 = $mol_type_enforce<
		ReturnType< $shm_hitalama_taskmanager_card['delete'] >
		,
		ReturnType< $mol_button_major['click'] >
	>
	type $mol_pick__align_shm_hitalama_taskmanager_card_15 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['align'] >
	>
	type $mol_pick__hint_shm_hitalama_taskmanager_card_16 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_pick['hint'] >
	>
	type $mol_pick__trigger_content_shm_hitalama_taskmanager_card_17 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['trigger_content'] >
	>
	type $mol_pick__bubble_content_shm_hitalama_taskmanager_card_18 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_pick['bubble_content'] >
	>
	type $mol_button_minor__hint_shm_hitalama_taskmanager_card_19 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__enabled_shm_hitalama_taskmanager_card_20 = $mol_type_enforce<
		ReturnType< $shm_hitalama_taskmanager_card['next_enabled'] >
		,
		ReturnType< $mol_button_minor['enabled'] >
	>
	type $mol_button_minor__click_shm_hitalama_taskmanager_card_21 = $mol_type_enforce<
		ReturnType< $shm_hitalama_taskmanager_card['move_right'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_button_minor__sub_shm_hitalama_taskmanager_card_22 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_view__sub_shm_hitalama_taskmanager_card_23 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_hitalama_taskmanager_card_24 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $shm_hitalama_taskmanager_card extends $mol_view {
		hovered( next?: boolean ): boolean
		Hovered( ): $shm_hitalama_hovered
		focus_auto( ): any
		created_at_label( ): string
		Date( ): $mol_view
		Header( ): $mol_view
		priority( next?: string ): string
		Priority( ): $shm_hitalama_taskmanager_priority
		move_left( next?: any ): any
		Move_left_icon( ): $mol_icon_chevron_left
		Move_left( ): $mol_button_minor
		Left( ): $mol_view
		title( next?: string ): string
		Title( ): $shm_hitalama_textarea
		Delete_icon( ): $mol_icon_trash_can
		delete( next?: any ): any
		Delete_confirm( ): $mol_button_major
		Delete( ): $mol_pick
		move_right( next?: any ): any
		Move_right_icon( ): $mol_icon_chevron_right
		Move_right( ): $mol_button_minor
		Right( ): $mol_view
		Body( ): $mol_view
		task( next?: any ): any
		previous_enabled( ): boolean
		next_enabled( ): boolean
		plugins( ): readonly(any)[]
		auto( ): readonly(any)[]
		attr( ): ({ 
			'shm_hitalama_taskmanager_priority': ReturnType< $shm_hitalama_taskmanager_card['priority'] >,
			'shm_hitalama_taskmanager_card_hovered': ReturnType< $shm_hitalama_taskmanager_card['hovered'] >,
		})  & ReturnType< $mol_view['attr'] >
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=card.view.tree.d.ts.map